import React from 'react';
import {withState} from 'recompose';
import PropTypes from 'prop-types';
import {VideoPlaceholder, PlayIcon, Container, TitleContainer, Image, Title} from './styles';
import playIcon from 'assets/img/picto-play.png';

const Academie = ({
  hidePlaceholder,
  setHidePlaceholder,
  academie_miniature,
  academie_video,
  title,
  academie_sous_titre,
}) => (
  <Container>
    <iframe
      width="335"
      height="200"
      src={`https://www.youtube.com/embed/${academie_video}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Youtube video"
    />
    {!hidePlaceholder && (
      <VideoPlaceholder onClick={() => setHidePlaceholder(true)}>
        <Image src={academie_miniature} />
        <PlayIcon src={playIcon} />
      </VideoPlaceholder>
    )}
    <TitleContainer>
      <Title
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <Title
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: academie_sous_titre,
        }}
      />
    </TitleContainer>
  </Container>
);

Academie.propTypes = {
  academie_miniature: PropTypes.string,
  academie_video: PropTypes.string,
  title: PropTypes.string,
  academie_sous_titre: PropTypes.string,
  hidePlaceholder: PropTypes.bool.isRequired,
  setHidePlaceholder: PropTypes.func.isRequired,
};

export default Academie |> withState('hidePlaceholder', 'setHidePlaceholder', false);
